import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Table, Card, Spin, Typography, Button, Modal, Descriptions } from "antd";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppraisalEmployees from "./AppraisalEmployees";

const { Title } = Typography;

export default function TriggerAppraisal() {
    const { authData, backUrl } = useContext(AuthContext);
    const [appraisals, setAppraisals] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedAppraisal, setSelectedAppraisal] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]); 

    const fetchAppraisals = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${backUrl}/api/appraisal/appraisal-cycles/`, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`,
                },
            });

            if (res.data?.results?.length > 0) {
                setAppraisals(res.data.results);
            } else {
                setAppraisals([]);
                toast.info("No appraisal records found.", { position: "top-right" });
            }
        } catch (error) {
            console.error("Error fetching appraisals:", error);
            toast.error("Failed to fetch appraisal data.", { position: "top-right" });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAppraisals();
    }, []);

    const handleTriggerClick = (record) => {
        setSelectedAppraisal(record);
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedAppraisal(null);
    };

    const rowSelection = {
        selectedRowKeys: selectedIds,
        onChange: (selectedRowKeys) => {
            setSelectedIds(selectedRowKeys);
        },
        getCheckboxProps: (record) => ({
            disabled: record.status !== "Active", 
        }),
    };

    const columns = [
        {
            title: "Appraisal Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (text) => (
                <span
                    style={{
                        color: text === "Active" ? "#0e497b" : "#999",
                        fontWeight: 500,
                    }}
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Eligibility Date",
            dataIndex: "eligibility_date",
            key: "eligibility_date",
            render: (date) =>
                date ? new Date(date).toLocaleDateString("en-GB") : "-",
        },
        {
            title: "Employee Due Date",
            dataIndex: "employee_due_date",
            key: "employee_due_date",
            render: (date) =>
                date ? new Date(date).toLocaleDateString("en-GB") : "-",
        },
        {
            title: "Action",
            key: "action",
            render: (_, record) =>
                record.status === "Active" ? (
                    <Button
                        type="primary"
                        style={{
                            backgroundColor: "#0e497b",
                            borderColor: "#0e497b",
                            borderRadius: "6px",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor = "#1060a0")
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor = "#0e497b")
                        }
                        onClick={() => handleTriggerClick(record)}
                    >
                        Trigger
                    </Button>
                ) : (
                    <span style={{ color: "#aaa" }}>N/A</span>
                ),
        },
    ];

    return (
        <>
            <ToastContainer />
            <Title
                level={4}
                style={{
                    color: "#0e497b",
                    marginBottom: "20px",
                    textAlign: "center",
                }}
            >
                Appraisal Cycles
            </Title>

            {loading ? (
                <div style={{ textAlign: "center", padding: "40px" }}>
                    <Spin size="large" />
                </div>
            ) : (
                <Table
                    dataSource={appraisals}
                    columns={columns}
                    rowKey={(record) => record.id}
                    pagination={{ pageSize: 15 }}
                    rowSelection={rowSelection} 
                    components={{
                        header: {
                            cell: (props) => (
                                <th
                                    {...props}
                                    style={{
                                        backgroundColor: "#0e497b",
                                        color: "white",
                                        marginTop: "20px",
                                    }}
                                >
                                    {props.children}
                                </th>
                            ),
                        },
                    }}
                />
            )}

            {selectedIds.length > 0 && (
                <div
                    style={{
                        marginTop: "15px",
                        textAlign: "center",
                        color: "#0e497b",
                        fontWeight: 500,
                    }}
                >
                    Selected Appraisal IDs: {selectedIds.join(", ")}
                </div>
            )}

            {/* Modal for Trigger Action */}
            <Modal
                title={
                    <span style={{ color: "#0e497b", fontWeight: 600 }}>
                        Trigger Appraisal
                    </span>
                }
                width={1300}
                open={isModalOpen}
                onCancel={handleModalClose}
                footer={null}
                centered
            >
                <AppraisalEmployees SelectedAppId={selectedAppraisal?.id} />
            </Modal>
        </>
    );
}
